import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const getMpCatalogueDetails = async (id) => {
  const path = `/mp_catalogues/${id}/`;
  try {
    const response = await axiosInstance.get(path);
    return response.data;
  } catch (error) {
    console.error('Mp Catalogue Details API error:', error);
    throw error;
  }
};

export const useGetMpCatalogueDetails = (id) => {
  const { data, error, isLoading, isError, isFetching, refetch } = useQuery({
    queryKey: ['mp_catalogues', id],
    queryFn: () => getMpCatalogueDetails(id),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
    enabled: !!id,
  });
  return { data, error, isLoading, isError, refetch, isFetching };
};
